  $(document).ready(function(){
    if ($(window).width() < 768) { // Assuming mobile devices have a width less than 768px
      $('.slick-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
      if ($(window).width() < 768) { // Assuming mobile devices have a width less than 768px
      $('.main_cards').slick({
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
      });
    }
  });



